import {Button} from "../../../Form/Button/Button";
import {buttonColors} from "../../../Pickers/InputTheme";
import React from "react";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './UserDetailsCell.scss'
import {UserDetailsModal} from "../../../Users/UserDetailsModal/UserDetailsModal";
import {i18n} from "../../../../Utils/i18n/i18n";
import {get} from "lodash";

export const UserDetailsCell = ({user}) => {
    const [detailsUserModalOpen, setDetailsUserModalOpen] = React.useState(false)
    const editUser = () => {
        setDetailsUserModalOpen(true)
    }
    const closeCreateEditUserModal = () => {
        setDetailsUserModalOpen(false)
    }
    return <div className="EditUserCell">
        {!get(user, 'isCompanyAdmin') ? <Button color={buttonColors.GREY}
                                   size="small"
                                   icon={<InfoOutlinedIcon/>}
                                   onClick={editUser}/> : i18n.translate('createEditUserModal.userIsCompanyAdmin')}
        {<UserDetailsModal user={user} closeModal={closeCreateEditUserModal} modalOpen={detailsUserModalOpen}/>}
    </div>
}